var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.005 1-2.753 1.583-7.5 4.334L3 8.5v15l2.752 1.583 7.57 4.334L16.072 31l2.753-1.583 7.43-4.334L29.01 23.5v-15l-2.753-1.583-7.5-4.334L16.005 1zm-7.5 19.335v-8.67l7.5-4.335 7.5 4.335v8.67l-7.5 4.335-7.5-4.335z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkup);
export default __webpack_public_path__ + "static/media/LINKUP.fd75bb11978b0eb0915eed6852688302.svg";
export { ForwardRef as ReactComponent };